package one.healthium.data.user.utils

import co.touchlab.kermit.Logger
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.functions.functions
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.data.user.dto.CredentialsDto
import one.healthium.domain.user.models.SignInOptions

class SignInOptionsProvider {

    suspend fun get(token: String): SignInOptions? {
        try {
            return Firebase.functions.httpsCallable("exchangeMagicLinkToken")
                .invoke(mapOf("token" to token))
                .data<ExchangeTokenResponse>()
                .let { SignInOptions.CustomToken(it.customToken, it.email) }
        } catch (e: Exception) {
            Logger.e("failed token exchange", e)
        }

        return Firebase.firestore
            .collection("webUsers")
            .document(token)
            .get()
            .takeIf { it.exists }
            ?.data(CredentialsDto.serializer())
            ?.let { dto ->
                SignInOptions.Username(
                    dto.email,
                    dto.password
                )
            }
    }
}

@Serializable
private data class ExchangeTokenResponse(
    @SerialName("customToken") val customToken: String,
    @SerialName("email") val email: String,
)